import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import { Router, Route } from 'react-router-dom'
import { createBrowserHistory } from "history";
import * as serviceWorker from './serviceWorker';
import './index.css';
import './i18n';
import App from './pages/App';
import Callback from './pages/Callback';
import AcademicResult from './pages/AcademicResult'
import GpaPredict from './pages/GpaPredict';
import Logout from './pages/Logout'
import Loader from './pages/Loader'
import { store } from './redux/store'

const history = createBrowserHistory();

const RoutedApp = () => (
  <Router history={history}>
    <Route path={"/"} component={App} />
    <Route path={"/callback"} component={Callback} />
    <Route path={"/AcademicResult"} component={AcademicResult} />    
    <Route path={"/GpaPredict"} component={GpaPredict} />        
    <Route path={"/logout"} component={Logout} />
  </Router>
);

ReactDOM.render(  
  <Suspense fallback = {Loader()}  >
    <Provider store={store}>
      <RoutedApp />
    </Provider>
  </Suspense> , document.getElementById('root')
);

serviceWorker.unregister();